import React from 'react';
import { Record } from 'immutable';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useMeetingModeTracking } from 'Shared/tracking/use-meeting-mode-tracking';

// Types
import { WorkspaceMeetingModeState, WorkspaceMeetingMode } from 'Shared/types/WorkspaceMeetingMode.type';

// Constants
import WorkspaceMeetingModeConstants from 'Shared/constants/WorkspaceMeetingMode.constants';

// Actions
import * as WorkspaceMeetingModeActions from 'Shared/actions/WorkspaceMeetingMode.actions';

// Components
import { WpContainer, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import OtherActionItems from './OtherActionItem/OtherActionItems';
import CreatedInMeetingMode from './CreatedInMeetingMode/CreatedInMeetingMode';

// Styles
import './NextSteps.scss';

type Props = {
  meetingModeSession?: Record<WorkspaceMeetingMode>;
  handleNavigateToItem: Function;
  meetingItemOrderedKeys: Array<string>;
};

const NextSteps = ({ meetingModeSession, handleNavigateToItem, meetingItemOrderedKeys }: Props) => {
  const dispatch = useDispatch();
  const { trackPreviousClick } = useMeetingModeTracking();
  const { workspaceId } = useParams();

  const [isEnding, toggleIsEnding] = useToggle(false);
  const [isNavigatingBack, toggleIsNavigatingBack] = useToggle(false);

  const handleNavigateToPreviousClick = () => {
    toggleIsNavigatingBack();
    trackPreviousClick();
    handleNavigateToItem(meetingItemOrderedKeys[meetingItemOrderedKeys.length - 1], 'back');
  };

  const handleEndMeetingClick = () => {
    toggleIsEnding();
    const params = {
      [WorkspaceMeetingModeConstants.Params.STATE]: WorkspaceMeetingModeState.END_MEETING_MODE_SESSION,
    };

    dispatch(WorkspaceMeetingModeActions.updateMeetingModeV2(workspaceId, params));
  };

  const baseClassName = 'NextSteps';
  return (
    <div className={baseClassName}>
      <WpContainer className={`${baseClassName}__wrap-up-container`}>
        <WpContainerBody>
          <div className={`${baseClassName}__wrap-up-container__sub-title`}>Wrap Up</div>
          <div className={`${baseClassName}__wrap-up-container__title`}>Review Action Items</div>
        </WpContainerBody>
        <WpContainerFooter justifyContent="spaceBetween">
          <WpButton
            variant="tertiary"
            disabled={isEnding}
            loading={isNavigatingBack}
            onClick={handleNavigateToPreviousClick}
          >
            <WpIcon name="angle-left" />
            Previous Topic
          </WpButton>
          <WpButton onClick={handleEndMeetingClick} loading={isEnding}>
            End Discussion
          </WpButton>
        </WpContainerFooter>
      </WpContainer>
      <div className={`${baseClassName}__created-in-items`}>
        <CreatedInMeetingMode meetingModeSession={meetingModeSession} />
      </div>
      <div className={`${baseClassName}__other-items`}>
        <OtherActionItems meetingModeSession={meetingModeSession} />
      </div>
    </div>
  );
};

export default NextSteps;
